import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { Container, Grid, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";

const DropdownMenu = ({
  menuOpen,
  items,
  onMouseEnter,
  onMouseLeave,
  onCloseMenu,
}) => {
  return (
    <>
      {/* Overlay */}
      {menuOpen && (
        <Box
          sx={{
            position: "fixed",
            top: "98px", // Empieza justo debajo del header
            left: 0,
            width: "100%",
            height: "calc(100% - 64px)", // Ajusta la altura para excluir el header
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Negro semitransparente
            zIndex: 1100, // Debajo del menú desplegable
          }}
          onClick={onCloseMenu} // Permite cerrar el menú al hacer clic en el overlay
        />
      )}

      {/* Menú desplegable */}
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: menuOpen ? "auto" : 0 }}
        transition={{ duration: menuOpen ? 0.5 : 0.2 }}
        style={{
          overflow: "hidden",
          backgroundColor: "#ffffff",
          position: "absolute",
          top: "64px", // Considerando las alturas de las barras superiores
          left: 0,
          width: "100%",
          zIndex: 1200,
          boxShadow:
            "0 -4px 8px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              display: "grid",
              gridTemplateColumns:
                items.length <= 3
                  ? `repeat(3, minmax(200px, 1fr))` // Si hay 3 o menos elementos, usa 3 columnas
                  : `repeat(auto-fit, minmax(200px, 1fr))`, // Si hay más elementos, usa columnas dinámicas
              gap: "16px",
            }}
          >
            {items.map((item, index) => (
              <Grid
                key={index}
                sx={{
                  padding: "16px",
                  borderRadius: "8px",
                  textAlign: "left",
                }}
              >
                {item.image && (
                  <Box
                    sx={{
                      width: "100%",
                      height: "150px",
                      marginTop: "16px",
                      overflow: "hidden",
                      marginBottom: "8px",
                    }}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                )}
                <Typography variant="h6" color="textPrimary">
                  {item.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.description}
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  component={Link}
                  to={item.link}
                  sx={{ marginTop: 1 }}
                  onClick={onCloseMenu}
                >
                  {item.buttonText || "Ver más"}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Container>
      </motion.div>
    </>
  );
};

DropdownMenu.propTypes = {
  menuOpen: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      link: PropTypes.string.isRequired,
      buttonText: PropTypes.string,
    })
  ).isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onCloseMenu: PropTypes.func.isRequired,
};

export default DropdownMenu;
